import times from 'lodash/times';
import React from 'react';

import * as S from './styles';

const REPETITIONS = 4;

type Props = {
  phrases: React.ReactNode[];
  speed?: number;
  repetitions?: number;
};

function Marquee(props: Props) {
  const { phrases, speed = 100, repetitions = REPETITIONS } = props;

  const displayChildren = times(repetitions, (repIndex) =>
    phrases.map((phrase, phraseIndex) => (
      <S.MarqueeChild key={`${repIndex}-${phraseIndex}`}>
        {phrase}
        <S.SeparatorContainer>
          <S.ShapeSeparator />
        </S.SeparatorContainer>
      </S.MarqueeChild>
    ))
  );

  return (
    <S.MarqueeContainer speed={speed}>{displayChildren}</S.MarqueeContainer>
  );
}

export default Marquee;
